module.exports = __webpack_public_path__ + "static/tree_leafs_ao-d9beb2f2b9b6fd0613f5e0dc4da37c47.png";